import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import EventosList from './pages/EventosList';
import FotosUpload from './pages/FotosUpload';
import FotosEvento from './pages/FotosEvento';
import Ventas from './pages/Ventas';
import MiCuenta from './pages/MiCuenta';
import AdminPagos from './pages/AdminPagos';
import AvisoPrivacidad from './pages/AvisoPrivacidad';
import TerminosUso from './pages/TerminosUso';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import UneteFotografos from './pages/UneteFotografos';
import SolicitudesFotografos from './pages/SolicitudesFotografos';
import Navbar from './components/Navbar';
import Topbar from './components/Topbar';
import { AuthProvider, useAuth } from './context/AuthContext';

// Componente para rutas protegidas
const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App app-layout">
          <Navbar />
          <Topbar />
          <div className="app-content">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/eventos" 
                element={
                  <PrivateRoute>
                    <EventosList />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/eventos/:eventoId/fotos" 
                element={
                  <PrivateRoute>
                    <FotosEvento />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/upload/:eventoId" 
                element={
                  <PrivateRoute>
                    <FotosUpload />
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/ventas" 
                element={
                  <PrivateRoute>
                    <Ventas />
                  </PrivateRoute>
                } 
              />
              <Route path="/mi-cuenta" element={<PrivateRoute><MiCuenta /></PrivateRoute>} />
              <Route path="/admin/pagos" element={<PrivateRoute><AdminPagos /></PrivateRoute>} />
              <Route path="/admin/solicitudes-fotografos" element={<PrivateRoute><SolicitudesFotografos /></PrivateRoute>} />
              <Route path="/unete-fotografos" element={<UneteFotografos />} />
              <Route path="/aviso-privacidad" element={<AvisoPrivacidad />} />
              <Route path="/terminos" element={<TerminosUso />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/" element={<Navigate to="/login" />} />
            </Routes>
            <footer className="app-footer">
              © 2026 Xaltech Manufacturing Services SA de CV &nbsp;·&nbsp;
              <Link to="/aviso-privacidad" style={{color:'#3b82f6', textDecoration:'none'}}>Aviso de Privacidad</Link>
              &nbsp;·&nbsp;
              <Link to="/terminos" style={{color:'#3b82f6', textDecoration:'none'}}>Términos de Uso</Link>
              &nbsp;·&nbsp;
              <Link to="/privacy-policy" style={{color:'#3b82f6', textDecoration:'none'}}>Privacy Policy</Link>
              &nbsp;·&nbsp;
              <Link to="/terms-of-service" style={{color:'#3b82f6', textDecoration:'none'}}>Terms of Service</Link>
            </footer>
          </div>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
